




























































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class TableTitle extends Vue {
    @Prop({ required: false }) readonly titles?: Record<string, any>;
    @Prop({ required: false }) readonly hiddenColumns?: [];
    @Prop({ required: false }) readonly sortFields?: [];
    @Prop({ required: false }) readonly isStatusColumn?: boolean;
    @Prop({ required: false }) readonly alignRightColumn?: [];
    @Prop({ required: false }) readonly isSettingsState?: boolean;

    toggleSort(id: string, sort: string) {
        this.$emit('toggleSort', { action: 'sort', field: id, sort });
    }

    handleDragDrop(column: any) {
        this.$emit('handleDragDrop', column);
    }
}
